import { useSyncExternalStore } from 'react';
import { SectionType } from '@/declarations/models/SectionType';

export type AddBlockPosition = 'top' | 'bottom';

const STORAGE_KEY = 'm24.pageEditor.addBlockPosition';
const listeners = new Set<() => void>();

const read = (): AddBlockPosition => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'top' ? 'top' : 'bottom';
  } catch {
    return 'bottom';
  }
};

let current: AddBlockPosition = read();

const setAddBlockPosition = (position: AddBlockPosition) => {
  current = position;
  try {
    localStorage.setItem(STORAGE_KEY, position);
  } catch {
    // Only remembered for this session then
  }
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** The head section always adds at the bottom, so there is no choice there */
export const canChooseAddPosition = (sectionType?: SectionType) => sectionType !== SectionType.ARTICLE_HEAD;

/** Where new modules go in a section. Shared by every section, and remembered in this browser. */
export const useAddBlockPosition = (): [AddBlockPosition, (position: AddBlockPosition) => void] => [
  useSyncExternalStore(subscribe, () => current),
  setAddBlockPosition,
];
